
import React, { useState, useEffect } from "react";
import FrontHeader from "../../../shared/FrontHeader/FrontHeader";
import BreadCrumb from "../../../shared/BreadCrumb";
import { useStepType } from "../../../../utils/type";
import { useStep } from "react-hooks-helper";
import PanierValidStep from "./steps/PanierValidStep";
import InformationsPersonnelles from ".//steps/InformationsPersonnelles";
import InformationsMedicales from ".//steps/InformationsMedicales";
import Consentement from ".//steps/Consentement";
import Confirmation from ".//steps/Confirmation";
import UseAddOrUpdateServiceForm from ".//requestForm/UseAddOrUpdateServiceForm";
import { useAppSelector } from "../../../../redux/hook";
import { useGetVendeurByApiKeyQuery } from "../../../../utils/api/product/product.api";
import { VendeurApikey } from "../../../../utils/http";
import { formatCurrency } from "../../../../utils/Utils";


// 5 étapes du parcours de réservation de service
const steps = [
  { id: "panier-validation", Component: PanierValidStep },
  { id: "informations-personnelles", Component: InformationsPersonnelles },
  { id: "informations-medicales", Component: InformationsMedicales },
  { id: "consentement", Component: Consentement },
  { id: "confirmation", Component: Confirmation },
];

const tabs = [
  { label: "Panier", breadcrumb: "mon panier" },
  { label: "Informations personnelles", breadcrumb: "Informations personnelles" },
  { label: "Informations médicales", breadcrumb: "Informations médicales" },
  { label: "Consentement", breadcrumb: "Consentement" },
  { label: "Confirmation", breadcrumb: "Confirmation" },
];

function ValidateService() {
  const { data: vendeur } = useGetVendeurByApiKeyQuery(VendeurApikey);
  const { cartItems, totalAmount } = useAppSelector((state) => state.cart);

  const {
    step,
    navigation: { go, next, previous },
    index,
  }: useStepType = useStep({ initialStep: 0, steps });
  const { Component } = step;
 useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [index]);

  const {
    register,
    onSubmit,
    isLoading,
    errors,
    handleChangePhone,
    phone,
    onChangeAdresse,
    adresse,
    setValue,
    watch,
    Controller,
    control,
    precedent,
  } = UseAddOrUpdateServiceForm(next, previous, cartItems, totalAmount);

  return (
    <div className="landing-page-component">
      <FrontHeader />
      <div className="page-content pb-5">
        <div className="container pt-4">
          <BreadCrumb pageName="mon panier" secondPage={tabs[index].breadcrumb} />

          <div className="validate-service-content pt-5 pb-5">
            {/* Indicateur d'étapes (cercles numérotés + lignes de connexion) */}
            <div className="service-stepper pb-5">
              {tabs.map((tab, key) => (
                <React.Fragment key={key}>
                  <div className="service-step">
                    <div
                      className={`service-step-circle ${
                        key < index ? "done" : ""
                      } ${key === index ? "active" : ""}`}
                    >
                      {key < index ? "✓" : key + 1}
                    </div>
                    <span
                      className={`service-step-label ${
                        key === index ? "active" : ""
                      }`}
                    >
                      {tab.label}
                    </span>
                  </div>
                  {key < tabs.length - 1 && (
                    <div
                      className={`service-step-line ${
                        key < index ? "done" : ""
                      }`}
                    ></div>
                  )}
                </React.Fragment>
              ))}
            </div>

            <div className="row row-validate">
              <div className="col-lg-9 validate-wrapper">
                <form onSubmit={onSubmit}>
                  <Component
                    register={register}
                    errors={errors}
                    handleChangePhone={handleChangePhone}
                    phone={phone}
                    vendeur={vendeur}
                    onChangeAdresse={onChangeAdresse}
                    adresse={adresse}
                    setValue={setValue}
                    watch={watch}
                    Controller={Controller}
                    control={control}
                    totalAmount={totalAmount}
                    vendeurDevise={vendeur?.devise}
                  />

                  <div className="action-btn-content d-flex justify-content-between align-items-center gap-3 pt-4">
                    {index >= 1 && cartItems.length > 0 && (
                      <button
                        className="step-action-btn validate-go-back-btn"
                        type="button"
                        onClick={precedent}
                      >
                        ← Retour
                      </button>
                    )}
                    <div className="ms-auto">
                      {index === 0 && cartItems.length > 0 && (
                        <button
                          className="step-action-btn parcours-submit-btn"
                          type="button"
                          onClick={() => next()}
                        >
                          Suivant →
                        </button>
                      )}
                      {index >= 1 && cartItems.length > 0 && (
                        <button
                          className="step-action-btn parcours-submit-btn"
                          type="submit"
                          disabled={isLoading}
                        >
                          {index === steps.length - 1
                            ? isLoading
                              ? "Validation ..."
                              : "Confirmer le rendez-vous"
                            : "Continuer →"}
                        </button>
                      )}
                    </div>
                  </div>
                </form>
              </div>

              <div className="col-lg-3">
                <div className="cart-card">
                  <h1 className="title pb-4">Total du panier</h1>
                  <div className="separator"></div>
                  <div className="total d-flex align-items-center justify-content-between pt-3">
                    <span className="sm-title">TOTAL</span>
                    <span className="sm-value total">
                      {formatCurrency(totalAmount, vendeur?.devise)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ValidateService;